import { z } from 'zod';
import type { OrigemVinculo, SituacaoLeitura, SituacaoVinculo } from '../enums/dominios';

// Envio de arquivos (ADR-0019, ADR-0020): a empresa envia os arquivos de um ou vários processos e acompanha a leitura;
// cada arquivo vai para o cartão do seu processo ou, na dúvida, para a bandeja "Arquivos sem processo".

/** Formatos aceitos no envio: PDF, Word e afins, planilhas, imagens e ZIP. */
export const EXTENSOES_ENVIO = ['pdf', 'docx', 'doc', 'odt', 'rtf', 'xlsx', 'xls', 'ods', 'csv', 'txt', 'md', 'html', 'htm', 'json', 'xml', 'log', 'png', 'jpg', 'jpeg', 'tif', 'tiff', 'bmp', 'zip'] as const;

export type DocumentoImportadoDto = { nome: string; situacao: SituacaoLeitura; paginas: number | null; erro: string | null };

export type ProcessoResumoDto = { uuid: string; numero: string; objeto: string };

/** Um arquivo enviado (ou tirado de um ZIP) e o vínculo dele com um processo do quadro. */
export type ArquivoEnviadoDto = {
  uuid: string;
  nome: string;
  /** Nome do ZIP de onde o arquivo saiu. */
  origemZip: string | null;
  leitura: SituacaoLeitura;
  paginas: number | null;
  erro: string | null;
  situacao: SituacaoVinculo;
  origem: OrigemVinculo | null;
  processo: ProcessoResumoDto | null;
  /** Processo provável quando há dúvida ("Parece ser do processo X"). */
  sugerido: ProcessoResumoDto | null;
  motivo: string | null;
  criadoEm: string;
};

export type ImportacaoDto = {
  uuid: string;
  situacao: SituacaoLeitura;
  criadaEm: string;
  documentos: DocumentoImportadoDto[];
  /** Importações antigas (uma licitação por envio): o processo que nasceu. */
  processoUuid: string | null;
  numero: string | null;
  objeto: string | null;
  erro: string | null;
  /** Processo onde os arquivos foram soltos (envio sobre o cartão). */
  destino: ProcessoResumoDto | null;
  arquivos: ArquivoEnviadoDto[];
};

/** Resposta do envio: arquivos recusados (formato, tamanho, ZIP) e a importação criada. */
export type ResultadoImportacaoDto = { importacao: ImportacaoDto | null; recusados: { nome: string; motivo: string }[] };

export const esquemaVincularArquivo = z.object({ processoUuid: z.string().uuid() });
export type VincularArquivoEntrada = z.infer<typeof esquemaVincularArquivo>;
